<template>
  <div class="awards-container">
    <div class="awards" @scroll="scrollSlider">
      <div class="award-offset"></div>
      <div class="award-item" key="0">
        <div class="i">
          <picture>
            <img :src="require('@/assets/img/reward-1.png')" alt="" />
          </picture>
        </div>
        <div class="t">
          <p>{{ $t("about.ratingAndAwardsOne") }}</p>
        </div>
      </div>
      <div class="award-item" key="1">
        <div class="i">
          <picture>
            <img :src="require('@/assets/img/reward-2.png')" alt="" />
          </picture>
        </div>
        <div class="t">
          <p>{{ $t("about.ratingAndAwardsTwo") }}</p>
        </div>
      </div>
      <div class="award-item" key="2">
        <div class="i">
          <picture>
            <img :src="require('@/assets/img/reward-3.png')" alt="" />
          </picture>
        </div>
        <div class="t">
          <p>{{ $t("about.ratingAndAwardsThree") }}</p>
        </div>
      </div>
      <div class="award-item" key="3">
        <div class="i">
          <picture>
            <img :src="require('@/assets/img/reward-4.png')" alt="" />
          </picture>
        </div>
        <div class="t">
          <p>{{ $t("about.ratingAndAwardsFour") }}</p>
        </div>
      </div>
      <div class="award-item" key="4">
        <div class="i">
          <picture>
            <img :src="require('@/assets/img/reward-5.png')" alt="" />
          </picture>
        </div>
        <div class="t">
          <p>{{ $t("about.ratingAndAwardsFive") }}</p>
        </div>
      </div>
      <div class="award-item" key="5">
        <div class="i">
          <picture>
            <img :src="require('@/assets/img/reward-6.png')" alt="" />
          </picture>
        </div>
        <div class="t">
          <p>{{ $t("about.ratingAndAwardsSix") }}</p>
        </div>
      </div>
      <div class="award-offset"></div>
    </div>
    <div class="dots">
      <span
        v-for="(item, index) in sliders"
        :key="item.id"

        :class="{ active: step === index }"
        @click.prevent="setStep(index)"
      >
      </span>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import cover from "@/mixins/cover";

export default {
  name: "AboutSlider",
  data: () => {
    return {
      step: 0,
      carouselPositions: [],
      halfContainer: 0,
      interval: false,
      sliders: [
        {
          src: "reward-1.png",
          // text: this.$t("about.ratingAndAwardsOne")
        },
        {
          src: "reward-2.png",
          // text: this.$t("about.ratingAndAwardsTwo")
        },
        {
          src:"reward-3.png",
          // text: this.$t("about.ratingAndAwardsThree")
        },
        // {
        //   src:"reward-4.png",
          // text: this.$t("about.ratingAndAwardsFour")
        // },
        // {
        //   src: "reward-5.png",
          // text:this.$t("about.ratingAndAwardsFive")
        // },
        // {
        //   src: "reward-6.png",
          // text:this.$t("about.ratingAndAwardsSix")
        // }
      ]
    };
  },
  mixins: [cover],
  computed: {
    ...mapState("slider", {
      indexBanner: state => state.index,
      indexLoading: state => state.indexLoading
    }),
    ...mapState({
      width: state => state.width,
      height: state => state.height
    }),
    ...mapState("home", {
      indexData: state => {
        console.log(state.index.blocks[0].sections[0].items);
        return state.index.blocks[0].sections[0].items;
      },
      indexLoading: state => state.indexLoading
    }),
  },
  created() {
    if (this.ASinterval) {
      clearInterval(this.ASinterval);
    }
    this.ASinterval = setInterval(() => {
      this.nextStep();
    }, 10000);
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
    clearInterval(this.ASinterval);
  },
  methods: {
    ...mapActions("slider", {
      actionIndex: "index"
    }),
    init() {
      this.$nextTick(() => {
        this.carouselPositions = [];

        document.querySelectorAll(".awards .award-item").forEach(
          function(div, index) {
            this.carouselPositions.push([
              index * div.offsetLeft,
              (index + 1) * div.offsetLeft // add to array the positions information
            ]);
          }.bind(this)
        );
      });
    },
    setStep(step) {
      try {
        this.step = step;
        clearInterval(this.ASinterval);
        this.ASinterval = setInterval(() => {
          this.nextStep();
        }, 10000);
        let slider = document.querySelector(".awards");
        if (slider) {
          slider.scrollTo({
            left: this.carouselPositions[this.step][0],
            behavior: "smooth"
          });
        }
      } catch (e) {
        console.log(e);
      }
    },
    prevStep() {
      if (this.step === 0) {
        this.step = this.carouselPositions.length - 1;
      } else {
        this.step--;
      }
      let slider = document.querySelector(".awards");
      if (slider) {
        slider.scrollTo({
          left: this.carouselPositions[this.step][0],
          behavior: "smooth"
        });
      }
    },
    nextStep() {
      try {
        if (this.carouselPositions.length - 1 === this.step) {
          this.step = 0;
        } else {
          this.step++;
        }
        let slider = document.querySelector(".awards");
        if (slider) {
          slider.scrollTo({
            left: this.carouselPositions[this.step][0],
            behavior: "smooth"
          });
        }
      } catch (e) {
        console.log(e);
      }
    },
    scrollSlider() {
      clearInterval(this.ASinterval);
      document.querySelectorAll(".awards .award-item").forEach((div, index) => {
        let rect = div.getBoundingClientRect();
        if (rect.left >= 0 && rect.left <= 180) {
          this.step = index;
        }
      });
      this.ASinterval = setInterval(() => {
        this.nextStep();
      }, 10000);
    }
  }
};
</script>

<style scoped></style>
